const firebaseConfig = {
    // apiKey:process.env.REACT_APP_APIKEY, 
    // authDomain:process.env.REACT_APP_AUTHDOMAIN, 
    // projectId:process.env.REACT_APP_PROJECTID,  
    // storageBucket:process.env.REACT_APP_STORAGEBUCKET, 
    // messagingSenderId:process.env.REACT_APP_MESSAGINGSENDERID,  
    // appId: process.env.REACT_APP_APPID
    
    apiKey: "AIzaSyC4EjR8ae2yGIYIKk9D1ASTsZ4OFcvOtBo",
  authDomain: "assinments11.firebaseapp.com",
  projectId: "assinments11",
  storageBucket: "assinments11.appspot.com",
  messagingSenderId: "795226730088",
  appId: "1:795226730088:web:9569c56767cd2ff21e55dd"
};
export default firebaseConfig;